export class UserDTO {
    constructor(ciam_id, name, last_name, email, token) {
        this.ciam_id = ciam_id;
        this.name = name;
        this.last_name = last_name;
        this.email = email;
        this.token = token;
    }
}